module.exports = __webpack_public_path__ + "static/img/9b58fb70-7476-47b8-91bd-e6295d586b68.8d95be1d.png";